import React, { FC, memo } from 'react';

import EditableListTab from 'components/ResqlExpert/SubmissionForm/EditableListTab';

const Participants: FC = () => (
  <EditableListTab
    fieldName="involved_parties"
    group="participant"
    titleKey="tab_participants"
    hintKey="tab_participants_hint"
  />
);

export default memo(Participants);
